import React from 'react';
import '../styles/AgenticTimelineChip.css';
import { Neuron, Tick } from "../assets/icons";
import { colour } from "../styles/GlobalStyles";

function AgenticTimelineChip(props) {
    const loaded = props.loaded;
    return (
        <div className="agentic-timeline-chip-container">
            {
                loaded === true ?
                <Tick
                    fill={colour.gray05}
                    className=""
                />
                :
                <Neuron />
            }
        </div>
    )
};

export default AgenticTimelineChip;